import { CREW_RESPONSIBILITIES, getCrewResponsibility } from './crewRosterAssignment';

export type CrewTimeLabel = 'Your Pack-in Start' | 'Your Call Time';
export type EquipmentArrivalLabel =
  | 'Equipment Pickup Required'
  | 'Meet at Venue'
  | 'Pickup Instructions Not Specified';

export type CrewAssignmentDisplay = {
  timeLabel: CrewTimeLabel;
  equipmentArrivalLabel: EquipmentArrivalLabel;
  equipmentPickupTime: string | null;
};

export const crewEquipmentResponsibilityText = (label?: EquipmentArrivalLabel) => {
  if (label === 'Equipment Pickup Required') return 'Collect Equipment / Pack-in';
  if (label === 'Meet at Venue') return 'Meet at Venue';
  return 'Instructions Not Yet Confirmed';
};

/**
 * Derives presentation labels only from explicit per-assignment data.
 * Role names, event pack-in and event start are deliberately ignored.
 */
export function getCrewAssignmentDisplay(crewRecord: Record<string, unknown> | null | undefined): CrewAssignmentDisplay {
  const record = crewRecord || {};
  const responsibility = getCrewResponsibility(record);
  const packInResponsible = responsibility === CREW_RESPONSIBILITIES.COLLECT_EQUIPMENT_PACK_IN;
  const pickupRequired = packInResponsible;
  const meetAtVenue = responsibility === CREW_RESPONSIBILITIES.MEET_AT_VENUE;
  const pickupTime = typeof record.equipment_pickup_time === 'string' && record.equipment_pickup_time.trim()
    ? record.equipment_pickup_time.trim()
    : null;

  return {
    timeLabel: packInResponsible ? 'Your Pack-in Start' : 'Your Call Time',
    equipmentArrivalLabel: pickupRequired
      ? 'Equipment Pickup Required'
      : meetAtVenue
        ? 'Meet at Venue'
        : 'Pickup Instructions Not Specified',
    equipmentPickupTime: pickupRequired ? pickupTime : null,
  };
}
